import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

const CommunicationsList = lazy(() => import('../../pages/communications/CommunicationsList'));
const AddCommunication = lazy(() => import('../../pages/communications/AddCommunication'));
const updateCommunication = lazy(() => import('../../pages/communications/EditCommunication'));
const AddEmailTemplate = lazy(() => import('../../pages/communications/email-templates/AddTemplate'));
const EditEmailTemplate = lazy(() => import('../../pages/communications/email-templates/EditTemplate'));
const EmailTemplatesList = lazy(() => import('../../pages/communications/email-templates/TemplatesList'));

const CommunicationMessages = lazy(() => import('../../pages/communications/overview/messages'));

const WhatsappTemplateList = lazy(() =>
    import('../../pages/communications/whatsapp-templates/TemplatesList-Table-View'),
);
const AddWhatsappTemplatesList = lazy(() => import('../../pages/communications/whatsapp-templates/AddTemplate'));
const EditWhatsappTemplate = lazy(() => import('../../pages/communications/whatsapp-templates/EditTemplate'));

function PagesRoute() {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route exact path={`${path}/email-templates/add`} component={AddEmailTemplate} />
            <Route exact path={`${path}/email-templates/:id`} component={EditEmailTemplate} />
            <Route exact path={`${path}/email-templates`} component={EmailTemplatesList} />

            <Route exact path={`${path}/whatsapp-templates`} component={WhatsappTemplateList} />
            <Route exact path={`${path}/whatsapp-templates/add`} component={AddWhatsappTemplatesList} />
            <Route exact path={`${path}/whatsapp-templates/edit/:id`} component={EditWhatsappTemplate} />

            <Route exact path={`${path}`} component={CommunicationsList} />
            <Route exact path={`${path}/add`} component={AddCommunication} />
            <Route exact path={`${path}/edit/:id`} component={updateCommunication} />
            <Route exact path={`${path}/:communicationId/overview/messages`} component={CommunicationMessages} />
            {/* <Route path={`${path}`} component={Users} /> */}
        </Switch>
    );
}

export default PagesRoute;
